import { SuperUserGuard } from "../../guards/permission.guard";
import { MonitoringComponent } from "./monitoring.component";
import { MonitoringStatusComponent } from "./status/monitoring-status.component";
import { MonitoringTargetsComponent } from "./targets/monitoring-targets.component";
import { MonitoringAlertsComponent } from "./alerts/monitoring-alerts.component";
import { MonitoringEventLogComponent } from "./event-log/monitoring-event-log.component";
import { Routes } from "@angular/router";

export const MonitoringRoutes: Routes = [
  {
    path: "monitoring-platforms",
    component: MonitoringComponent,
    canActivate: [SuperUserGuard],
    children: [
      { path: "status", component: MonitoringStatusComponent },
      { path: "outputs", component: MonitoringTargetsComponent },
      { path: "alerts", component: MonitoringAlertsComponent },
      { path: "event-logs", component: MonitoringEventLogComponent },
      { path: "**", redirectTo: "status" },
    ],
  },
];
